var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative flex justify-center w-full py-6 bg-slate-200",
      attrs: { id: "client-about-base" }
    },
    [
      _c(
        "div",
        {
          key: _vm.id,
          staticClass:
            "w-full max-w-5xl py-10 border bg-pure-white rounded-3xl border-slate-400"
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-1 px-10" },
            [
              _c("BlTextTitle4", { attrs: { text: "About" } }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: { text: "Your client's personal details" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-10 py-6 client-personal-information" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-4 mb-4" },
              [
                _c("BlTextSubtitle1", {
                  attrs: { text: "Personal information" }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "Edit" },
                  on: {
                    clicked: function($event) {
                      _vm.editAboutOpened = true
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-col gap-5" }, [
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Name" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 text-slate-1000",
                    attrs: { text: _vm.client.name }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Date of birth" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 text-slate-1000",
                    attrs: { text: _vm.displayDate(_vm.client.birthday) }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Status" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-wrap items-center col-span-3 gap-2"
                    },
                    [_c("BlChip", { attrs: { chip: _vm.client.status } })],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Date admitted" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 text-slate-1000",
                    attrs: { text: _vm.displayDate(_vm.client.admitted_at) }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Date of discharge" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 text-slate-1000",
                    attrs: { text: _vm.displayDate(_vm.client.archived_at) }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.enableSalesPipeline
                ? _c(
                    "div",
                    { staticClass: "grid grid-cols-4 gap-x-4" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "mt-0.5",
                        attrs: { text: "Discharge reason" }
                      }),
                      _vm._v(" "),
                      !_vm.client.discharge_reason
                        ? _c("BlTextBody2", {
                            staticClass: "col-span-3 text-slate-1000",
                            attrs: { text: "-" }
                          })
                        : _c("BlTextBody2", {
                            staticClass: "col-span-3 text-slate-1000",
                            attrs: {
                              text:
                                _vm.client.discharge_reason === "other"
                                  ? _vm.client.other_discharge_reason
                                  : _vm.dischargeReasonOptions[
                                      _vm.client.discharge_reason
                                    ]
                            }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Gender" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 capitalize text-slate-1000",
                    attrs: { text: _vm.client.gender || "-" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Email" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "col-span-3 text-slate-1000",
                    attrs: { text: _vm.client.email || "-" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Note" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass:
                      "col-span-3 whitespace-pre-line text-slate-1000",
                    attrs: { text: _vm.client.note || "-" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.enableBranch
                ? _c(
                    "div",
                    { staticClass: "grid grid-cols-4 gap-x-4" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "mt-0.5",
                        attrs: { text: "Branch tags" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-wrap items-center col-span-3 gap-2"
                        },
                        [
                          !_vm.client.branches.length
                            ? _c("BlTextBody2", { attrs: { text: "-" } })
                            : _vm._l(_vm.client.branches, function(branch) {
                                return _c(
                                  "div",
                                  {
                                    key: branch.id,
                                    staticClass:
                                      "flex items-center justify-center px-2 truncate rounded h-7 max-w-64",
                                    style: {
                                      backgroundColor:
                                        branch.background_color || "unset"
                                    },
                                    attrs: { title: branch.name || "-" }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "truncate",
                                      style: { color: branch.color || "unset" },
                                      attrs: { text: branch.name || "-" }
                                    })
                                  ],
                                  1
                                )
                              })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-4 gap-x-4" },
                [
                  _c("BlTextBody2", {
                    staticClass: "mt-0.5",
                    attrs: { text: "Client tags" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-wrap items-center col-span-3 gap-2"
                    },
                    [
                      !_vm.client.tags.length
                        ? _c("BlTextBody2", { attrs: { text: "-" } })
                        : _vm._l(_vm.client.tags, function(tag) {
                            return _c(
                              "div",
                              {
                                key: tag.id,
                                staticClass:
                                  "flex items-center justify-center px-2 truncate rounded h-7 max-w-64 bg-slate-300",
                                attrs: { title: tag.name || "-" }
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "truncate text-slate-800",
                                  attrs: { text: tag.name || "-" }
                                })
                              ],
                              1
                            )
                          })
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full h-5 bg-slate-200" }),
          _vm._v(" "),
          _c("div", { staticClass: "px-10 py-6 client-abc-data" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-4 mb-4" },
              [
                _c("BlTextSubtitle1", { attrs: { text: "ABC data" } }),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "Add new" },
                  on: {
                    clicked: function($event) {
                      _vm.newAssessmentOpened = true
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            !_vm.assessments.length
              ? _c(
                  "div",
                  { staticClass: "grid h-64 place-items-center" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "Oops, there are no ABC data available" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "flex flex-col gap-4" },
                  _vm._l(_vm.assessments, function(assessment) {
                    return _c("ClientAboutAssessment", {
                      key: assessment.id,
                      attrs: { assessment: assessment }
                    })
                  }),
                  1
                )
          ]),
          _vm._v(" "),
          _vm.editAboutOpened
            ? _c("EditClientAboutModal", {
                on: {
                  "close-modal": function($event) {
                    _vm.editAboutOpened = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.newAssessmentOpened
            ? _c("NewAssessmentModal", {
                on: {
                  "close-modal": function($event) {
                    _vm.newAssessmentOpened = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ddd850a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ddd850a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientAbout.vue
// module id = null
// module chunks = 